import { useCallback, useEffect, useState } from 'react';

import { type ReviewsWidgetData } from '../../shared/reviews';
import { fetchProductReviewsWidgetData } from '../services/fetchProductReviewsWidgetData';
import { useProduct } from './useProduct';

type UseWidgetDataReviews = {
    reviewsWidgetData: ReviewsWidgetData | null;
};

export const useWidgetDataReviews = (): UseWidgetDataReviews => {
    const { productId, tenant } = useProduct();
    const [reviewsWidgetData, setReviewsWidgetData] = useState<ReviewsWidgetData | null>(null);
    const [isFetched, setIsFetched] = useState(false);

    const fetchReviewsWidgetData = useCallback(async () => {
        const response = await fetchProductReviewsWidgetData(productId, tenant);

        if (response && response?.reviews?.length > 0) {
            setReviewsWidgetData(response);
        }

        setIsFetched(true);
    }, [productId, reviewsWidgetData, tenant]);

    useEffect(() => {
        if (!isFetched) {
            fetchReviewsWidgetData();
        }
    }, [fetchReviewsWidgetData, isFetched]);

    return { reviewsWidgetData };
};
